import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';
import SpinWheel from '../components/SpinWheel';

export default function SpinWheelPage() {
  const { user, refreshUser } = useAuth();
  const [segments, setSegments] = useState([]);

  useEffect(() => {
    api.get('/spins/config').then(setSegments).catch(() => {});
  }, []);

  const handleSpin = async () => {
    const data = await api.post('/spins/use');
    await refreshUser();
    return data;
  };

  return (
    <div className="spin-page">
      <h1 style={{ marginBottom: 8 }}>Spin the Wheel</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 16, textAlign: 'center' }}>
        Use a spin token for a chance to win points, rewards, and more!
      </p>
      <SpinWheel onSpin={handleSpin} spinTokens={user?.spin_tokens || 0} segmentsFromApi={segments} />
    </div>
  );
}
